export default "__VITE_ASSET__WndsBQjc__"